<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("wms.menu.inventory_history") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <base-button
            size="md"
            type="neutral"
            @click="handleInventoryHistory()"
            >{{ $t("back") }}</base-button
          >
        </div>
      </div>
    </base-header>

    <div class="row">
      <div class="container-fluid mt--6 col-lg-4">
        <div>
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <template slot="header">
              <div class="row">
                <label class="col-md-6 col-form-label form-control-label">
                  <h3 class="mb-0">{{ $t("wms.menu.inventory_history") }}</h3>
                </label>
              </div>
            </template>
            <!-- List Of data -->
            <div class="form-group row" >
              <label class="col-md-4 pl-6 col-form-label form-control-label">
                {{ $t("wms.bill_number") }}
              </label>
              <div class="col-md-7">
                <base-input v-model="Head.BillNumber"></base-input>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-4 pl-6 col-form-label form-control-label">
                {{ $t("wms.note") }}
              </label>
              <div class="col-md-7">
                <base-input v-model="Head.Note"></base-input>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-4 pl-6 col-form-label form-control-label">
                {{ $t("wms.staff") }}
              </label>
              <div class="col-md-7">
                <base-input v-model="Head.UserName"></base-input>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-4 pl-6 col-form-label form-control-label">
                วันที่
              </label>
              <div class="col-md-7">
                <base-input v-model="Head.CreateAt"></base-input>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-12">
                <img :src="Head.BillImage" @click="ZoomImage" width="100%" />
              </div>
            </div>
          </card>
        </div>
      </div>

      <!-- Product -->
      <div class="container-fluid mt--6 col-lg-8">
        <div>
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <template slot="header">
              <div class="row">
                <label class="col-md-6 col-form-label form-control-label">
                  <h3 class="mb-0">รายการ</h3>
                </label>
                
              </div>
            </template>
            <div>
              <el-table
                :data="Detail"
                row-key="id"
                header-row-class-name="thead-light"
                @sort-change="sortChange"
                @selection-change="selectionChange"
              >
                <el-table-column min-width="200px" label="คลังสินค้า">
                  <div slot-scope="{ $index, row }">
                    {{ row.StorageName }}- {{ row.ProductName }}
                  </div>
                </el-table-column>

                <el-table-column min-width="200px" label="จำนวน">
                  <div slot-scope="{ $index, row }">
                    {{ row.Quantity }}
                  </div>
                </el-table-column>

                <el-table-column min-width="200px" label="ประเภท">
                  <div slot-scope="{ $index, row }">
                    <template v-if="row.Type == 1">เพิ่มสินค้า</template>
                    <template v-if="row.Type == 0">ลดสินค้า</template>
                    <template v-if="row.Type == 2">ส่งสินค้า</template>
                    

                  </div>
                </el-table-column>

                <el-table-column min-width="200px" label="Note">
                  <div slot-scope="{ $index, row }">
                    {{ row.Note }}
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div
              slot="footer"
              class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
              <div class="">
                <p class="card-category">
                  {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                  {{ $t("of") }}
                  {{ total }}
                  <span v-if="selectedRows.length">
                    - &nbsp; &nbsp; {{ selectedRows.length }}
                    {{ $t("row_select") }}
                  </span>
                </p>
              </div>
              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              >
              </base-pagination>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import error from "./error";
import { mapGetters, mapActions } from "vuex";
import FileInput from "@/components/Inputs/FileInput";

export default {
  mixins: [clientPaginationMixin],
  components: {
    FileInput,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "WmsInventory/getData",
      Head: "WmsInventory/getHistoryHead",
      Detail: "WmsInventory/getHistoryDetail",
    }),
    tableData: function () {
      return this.History;
    },
    tableProduct: function () {
      return [
        {
          prop: "Name",
          label: this.$t("wms.product"),
          minWidth: 90,
          sortable: true,
        },
      ];
    },
    tableColumns: function () {
      return [
        {
          prop: "InventoryName",
          label: "คลังสินค้า",
          minWidth: 90,
          sortable: true,
        },
        {
          prop: "Balance",
          label: this.$t("wms.amount"),
          minWidth: 120,
          sortable: true,
        },
        {
          prop: "Note",
          label: "Note",
          minWidth: 120,
          sortable: true,
        },
      ];
    },
  },
  data() {
    return {
      selectedRows: [],
      BillNumber: "",
      Note: "",
      Staff: "",
      History: [],
    };
  },
  mounted() {
    this.HistoryDetail(this.$route.params.id);
  },
  methods: {
    ...mapActions({
      HistoryDetail: "WmsInventory/HistoryDetail",
    }),

    handleInventoryHistory() {
      this.$router.push("/wms/history");
    },

    ZoomImage() {
      var image = new Image();
      image.src = this.Head.BillImage;
      var w = window.open("");
      w.document.write(image.outerHTML);
    },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
};
</script>
<style scope>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
